import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const Modal = ({
  children,
  nbStep,
  onCancel,
  open,
  closable = true,
  width,
  height,
  step,
  subTitle,
  title,
  withStep = false,
  removeMargin = false,
  styles = {}
}) => {
  const {
    css,
    theme: { fontSizes },
  } = useStyles();

  return (
    <Dialog
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 45, 117, 0.6)',
        },
      }}
      classes={{
        paperScrollPaper: css({
          width: '100%',
          height: 'auto',
          minHeight: height || "auto",
          maxWidth: window.innerWidth < 564 ? window.innerWidth - 64 : width || 500,
          borderRadius: 20,
          position: 'relative',
          overflow: 'visible',
          "& .MuiTypography-root": {
            margin: removeMargin ? 0 : "inherit"
          }
        }),
      }}
      onClose={onCancel}
      open={open}
    >
      {closable && (
        <IconButton
          className={css({
            position: 'absolute',
            background: 'white',
            color: '#045ff9',
            top: -10,
            right: -10,
            '&:hover': {
              background: 'white',
              color: '#045ff9',
            },
          })}
          onClick={onCancel}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      )}
      {title && (
        <DialogTitle
          className={css({
            color: 'white',
            background: '#0060F9',
            textAlign: 'center',
            borderTopLeftRadius: 20,
          })}
        >
          <div className={css({ display: 'flex', flexDirection: 'column' })}>
            <div
              className={css({ '@media only screen and (max-width:1920px)': { fontSize: '15.00px' }, '@media only screen and (max-width:1600px)': { fontSize: '14.00px' }, fontWeight: 'bold', textTransform: 'none' })}
            >
              {title.toUpperCase()}
            </div>
            <div className={css({ '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' }, textTransform: 'none' })}>{subTitle}</div>
            {withStep && (
              <div className={css({ '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' }, fontWeight: 600, textTransform: 'lowercase' })}>
                {step} / {nbStep}
              </div>
            )}
          </div>
        </DialogTitle>
      )}
      <DialogContent
        className={css({
          ...styles
        })}
      >
        <DialogContentText
        >{children}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

Modal.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node,
  title: PropTypes.node,
  onCancel: PropTypes.func,
  step: PropTypes.number,
  subTitle: PropTypes.string,
  nbStep: PropTypes.number,
  withStep: PropTypes.bool,
};

export default Modal;
